<template>
    <div class="lms__superadmin_workspaces_edit_services">
      <component-title :size="'medium'">{{ $t('lms.workspace.title.services') }}</component-title>
        <form-list-select
            :allow-create="false"
            :labels="[this.$t('lms.workspace.labels.name'), this.$t('lms.workspace.labels.description'), this.$t('lms.workspace.labels.expiryDate'), this.$t('lms.workspace.labels.status')]"
            :name="'service'"
            :items="[
                {
                    name: 'EBS',
                    description: 'Lorem ipsum',
                    expiryDate: '01 Jan 2020',
                    status: this.$t('lms.workspace.labels.active')
                },
                {
                    name: 'Digital Workbook',
                    description: 'Dolor sit amet',
                    expiryDate: '01 Jan 2021',
                    status: this.$t('lms.workspace.labels.Draft')
                }
            ]"
            :size="'full'"
        />
        <pop-notify
            ref="popnotifyvalidation"
            :class="'pop__notify--validation'"
            :title-text="`Something's not quite right`"
            :content-text="'Please check that you have filled out all the fields in the form correctly and try again.'"
            :cancel-button-text="'Ok'"
            :submit-button-active="false"
        />
    </div>
</template>

<script>
import PopNotify from '@/components/default/shared/PopNotify'
import FormListSelect from '@/components/default/forms/FormListSelect'
import ComponentTitle from '@/components/default/shared/ComponentTitle'
export default {
  name: 'lms-superadmin-workspace-edit-services',
  components: { FormListSelect, PopNotify, ComponentTitle },
  computed: {
    customerAddressAddress1: {
      get () {
        return this.$store.getters.getLmsSuperadminCustomerAddressAddress1
      }
    }
  },
  methods: {
    validateBeforeRouteLeave: function (to) {
      if (to.name.includes('customer-edit') || to.name.includes('customer-add')) {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.$parent.validated = true
            this.$router.push({ path: to.path })
          } else {
            this.$refs.popnotifyvalidation.openNotify()
          }
        })
      } else {
        this.$parent.validated = true
        this.$router.push({ path: to.path })
      }
    },
    allowRedirectBeforeRouteLeave: function () {
      this.$eventBus.$emit('customer-submit')
    },
    //
    customerSubmit: function () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.$route.name.includes('customer-add')) {
            this.$store.dispatch('lmsSuperadminCustomerCreate')
          } else if (this.$route.name.includes('customer-edit')) {
            this.$store.dispatch('lmsSuperadminCustomerUpdate')
          }
          this.allowRedirectBeforeRouteLeave()
        } else {
          this.$refs.popnotifyvalidation.openNotify()
        }
      })
    }
  }
}
</script>
